import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'
import './images/yet.svg'
import './images/done.svg'

global.jQuery = $
require('jquery-ujs')

const incrementHelpfulCount = () => {
  // セレクタ定義
  const ROOT_TARGET_SELECTOR = '.js-incrementHelpfulCount-root-target'
  const BUTTON_TARGET_SELECTOR = '.js-incrementHelpfulCount-button-target'
  const COUNTER_NUMBER_TARGET_SELECTOR = '.js-incrementHelpfulCount-counterNumber-target'

  // data属性の定義
  const RECORD_TYPE_DATA_NAME = 'record-type'
  const RECORD_ID_DATA_NAME = 'record-id'
  const COUNTER_NUMBER_DATA_NAME = 'counter-number'

  // 未評価状態のクラス定義
  const UNRATED_CLASS_NAME = 'helpful-widget--unrated'

  // 完了状態のクラス定義
  const DONE_CLASS_NAME = 'helpful-widget--done'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $buttonTarget = $(root).find(BUTTON_TARGET_SELECTOR)
    const recordType = $buttonTarget.data(RECORD_TYPE_DATA_NAME)
    const recordId = $buttonTarget.data(RECORD_ID_DATA_NAME)
    const $counterNumberTarget = $(root).find(COUNTER_NUMBER_TARGET_SELECTOR)
    const currentCounterNumber = Number($counterNumberTarget.data(COUNTER_NUMBER_DATA_NAME))

    // ローカルストレージに保存するkey名の定義
    const LOCAL_STORAGE_KEY_NAME = `nurikae_already_helpful_list_of_${recordType}`

    // ローカルストレージから押したボタンのリストを取得
    const alreadyHelpfulList = window?.localStorage?.getItem(LOCAL_STORAGE_KEY_NAME)?.split(',')?.filter((v) => v) || []

    // 既に参考になったボタンを押したユーザーの場合は完了状態に変更する
    if (currentCounterNumber !== 0 && alreadyHelpfulList.includes(String(recordId))) {
      $(root).addClass(DONE_CLASS_NAME)
    }

    // 参考になったボタンを押したときの処理
    $buttonTarget.on('click', () => {
      // 1回以上評価された状態に変更
      $(root).removeClass(UNRATED_CLASS_NAME)

      // 既に評価済み完了状態に変更
      $(root).addClass(DONE_CLASS_NAME)

      // カウンターに+1する処理
      const afterNumber = currentCounterNumber + 1
      if (afterNumber <= 999) {
        $counterNumberTarget.text(afterNumber)
      } else {
        $counterNumberTarget.text('999+')
      }

      // ローカルストレージに該当IDを追加する
      alreadyHelpfulList.push(recordId)
      window?.localStorage?.setItem(LOCAL_STORAGE_KEY_NAME, alreadyHelpfulList.join(','))
    })
  })
}

$(() => {
  // 参考になったボタンを押したときの処理
  incrementHelpfulCount()
})
